import { gql } from '@apollo/client';

import { TL4Category } from 'Components/UserRequestPage/UserRequestPageHelpers';
import { AbstractCategory } from 'utils/graphql/categories';

type TL2Category = AbstractCategory & {
  ogDescription: string;
};

type TCity = {
  id: string;
  slug: string;
  name: string;
  region: {
    id: string;
    name: string;
  };
};

export type TGroupedCities = {
  cities: TCity[];
  region: {
    id: string;
    name: string;
  };
};

export interface L2CategoryCitiesData {
  l2BySlug: TL2Category;
  locationSuggestBigCities: TCity[];
}

export interface L4CategoryCitiesData {
  l4BySlug: AbstractCategory & TL4Category;
  locationSuggestBigCities: TCity[];
}

/* @ts-expect-error type mismatch */
const sortByRegion = (a, b) => {
  const regionA = a.region.name.toUpperCase();
  const regionB = b.region.name.toUpperCase();
  let comparison = 0;

  if (regionA > regionB) {
    comparison = 1;
  } else if (regionA < regionB) {
    comparison = -1;
  }

  return comparison;
};

export const groupCities = (cities: TCity[]): TGroupedCities[] => {
  const groupedCities = {};
  cities.forEach((city) => {
    /* @ts-expect-error type mismatch */
    if (groupedCities[city.region.name]) {
      /* @ts-expect-error type mismatch */
      groupedCities[city.region.name].cities.push(city);
    } else {
      /* @ts-expect-error type mismatch */
      groupedCities[city.region.name] = {
        cities: [city],
        region: city.region,
      };
    }
  });
  /* @ts-expect-error type mismatch */
  return Object.values(groupedCities).sort(sortByRegion);
};

export const L2CategoryCitiesQuery = gql`
  query L2category($slug: String!) {
    l2BySlug(slug: $slug, showHiddenCategories: false) {
      id
      slug
      name
      ogDescription
    }
    locationSuggestBigCities {
      id
      name
      slug
      region {
        id
        name
      }
    }
  }
`;

export const L4CategoryCitiesQuery = gql`
  query L4category($slug: String!) {
    l4BySlug(slug: $slug) {
      id
      slug
      name
      seoDescription
      l2 {
        id
        name
        slug
      }
    }
    locationSuggestBigCities {
      id
      name
      slug
      region {
        id
        name
      }
    }
  }
`;
